import { NavLink } from "react-router-dom";
import { getRoutePath } from "../../../../routes/routes";
import FrontFooter from "../../../../shared/FrontFooter/FrontFooter";
import FrontHeader from "../../../../shared/FrontHeader/FrontHeader";
import MesProjetsTable from "../../../Tables/mesProjets/MesProjetsTable";
import Sidebar from "../../Sidebar/Sidebar";
import ProjetsStats from "./ProjetsStats";
import "./ListeProjets.css";

function ListeProjets() {
  return (
    <div className="campagne-page-container">
      <FrontHeader />
      <div className="mon-compte">
        <div className="row g-0">
          <Sidebar index={0} />
          <div className="col-md-8 col-lg-9 col-xl-10 dashboard-page-content px-3 px-xl-4">
            <div className="mt-tableau-bord pt-4 pb-5">
              <div className="col-md-12">
                <ProjetsStats />
              </div>
              {/* L'action principale vient apres les chiffres : on regarde
                  d'abord ou on en est, on agit ensuite. */}
              <div className="col-md-12 d-flex justify-content-end mb-3">
                <NavLink
                  to={getRoutePath("LaunchACampain")}
                  className="btn-shop btn-shop-next fw-500 market-btn-link"
                >
                  Ajouter un projet
                </NavLink>
              </div>
              <div className="col-md-12 maajjal-table-card px-3 py-4">
                <MesProjetsTable />
              </div>
            </div>
          </div>
        </div>
      </div>
      <FrontFooter />
    </div>
  );
}

export default ListeProjets;
